module.exports = __webpack_public_path__ + "static/media/partTimeJob_icon.7d8ce0ae.svg";